import { UpdatesTable } from './UpdatesTable';

interface UpdatesTabProps {
  initiativeId: string;
}

export const UpdatesTab = ({ initiativeId }: UpdatesTabProps) => {
  return <UpdatesTable initiativeId={initiativeId} />;
};
